<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/lzxzF9/images/9780374719067.jpg?1726444398018" alt="This image is the cover for the book Mothers"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mothers
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An “extraordinary” (<i>The Sunday Times</i>) debut of unnerving beauty, Chris Power’s short story collection <i>Mothers </i>evokes the magic and despair of the essential human longing for purpose.</b><br/><br/>Chris Power’s stories are peopled by men and women who find themselves at crossroads or dead ends—characters who search without knowing what they seek. Their paths lead them to thresholds, bridges, rivers, and sites of mysterious, irresistible connection to the past. A woman uses her mother’s old travel guide, aged years beyond relevance, to navigate on a journey to nowhere; a stand-up comic with writer’s block performs a fateful gig at a cocaine-fueled bachelor party; on holiday in Greece, a father must confront the limits to which he can keep his daughters safe. Braided throughout is the story of Eva, a daughter, wife, and mother, whose search for a self and place of belonging tracks a devastating path through generations.<br/><br/>Ranging from remote English moors to an ancient Swedish burial ground to a hedonistic Mexican wedding, the stories in <i>Mothers </i>lay bare the emotional and psychic damage of life, love, and abandonment. Suffused with yearning, Power’s transcendent prose expresses a profound ache for vanished pasts and uncertain futures.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Power
      </h2>
      
      <p class="authorDescription body article"><B>Chris Power</B> lives and works in London. His column, A Brief Survey of the Short Story, has appeared in <I>The Guardian </I>since 2007. He has written for the BBC, <I>The New York Times</I>, and the <I>New Statesman</I>.<I></I>His fiction has been published in <I>Granta</I>, <I>The Stinging Fly</I>, <I>The Dublin Review</I>, and <I>The White Review</I>, and been broadcast on BBC Radio 4. <I>Mothers</I> is his first book.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?78276077